import { Flex, Text } from "@radix-ui/themes";
import React from "react";
import { Table, TableBody, TableCell, TableRow } from "./ui/table";
import { cn } from "@/lib/utils";
import Link from "next/link";

interface Props {
  header: string;
  content: { start: string; end?: string }[] | React.ReactNode;
}
const FooterItem = ({ header, content }: Props) => {
  const isArray = (item: any): item is { start: string; end?: string }[] => {
    return Array.isArray(item) && item.every((i) => "start" in i);
  };

  if (header === "logo" && React.isValidElement(content)) {
    return <Link href="#">{content}</Link>;
  }

  return (
    <Flex direction={"column"} className="gap-1">
      <Text className={cn("font-medium text-center lg:text-start")}>
        {header}
      </Text>
      {isArray(content) ? (
        <Table>
          <TableBody>
            {content.map((item, index) => (
              <TableRow
                key={index}
                className={cn(
                  "gap-4 border-0",
                  !item.end && "text-center lg:text-start"
                )}
              >
                <TableCell className="p-0 pr-6 m-0">{item.start}</TableCell>
                {item.end && (
                  <TableCell className="p-0 m-0">{item.end}</TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        content
      )}
    </Flex>
  );
};

export default FooterItem;
